// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export { XhrHttpClient as DefaultHttpClient } from "./xhrHttpClient";
